module.exports = __webpack_public_path__ + "img/6_90.554b1629.png";